import React from 'react';
import { Pressable, View } from 'react-native';
import { fmt, formatClockTime, isParcel } from '@restorant/core';
import type { Order } from '@restorant/core';
import { radius, useColors } from '../theme';
import { useItemsLabel, useT, useTableLabel } from '../i18n';
import { Icon } from '../icons/Icon';
import { T } from './Text';

/** One line in the order history. Tapping it opens the full receipt. */
export function OrderRow({ order, onPress }: { order: Order; onPress: () => void }) {
  const colors = useColors();
  const t = useT();
  const tableLabel = useTableLabel();
  const items = useItemsLabel();
  const who = order.customer.name.trim();

  return (
    <Pressable
      onPress={onPress}
      style={({ hovered, pressed }: any) => ({
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12,
        paddingVertical: 12,
        paddingHorizontal: 14,
        backgroundColor: colors.surface2,
        borderRadius: radius.md,
        borderWidth: 1,
        borderColor: hovered ? colors.goldDim : colors.line,
        marginBottom: 8,
        opacity: pressed ? 0.85 : 1,
      })}
    >
      <View
        style={{
          width: 36,
          height: 36,
          borderRadius: radius.sm,
          backgroundColor: colors.surface,
          borderWidth: 1,
          borderColor: colors.line,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Icon name={isParcel(order.tableId) ? 'parcel' : 'table'} size={16} color={colors.gold} />
      </View>

      <View style={{ flex: 1, gap: 3, minWidth: 0 }}>
        <T size={13.5} weight={700} numberOfLines={1}>
          {t('order_no', { n: order.orderNo ?? order.localNo })} · {tableLabel(order.tableId)}
        </T>
        <T size={11.5} color={colors.textFaint} numberOfLines={1}>
          {items(order.qty)} · {formatClockTime(new Date(order.placedAt))}
          {who ? ` · ${who}` : ''}
        </T>
      </View>

      {!order.synced ? (
        <Icon name="cloudUp" size={15} color={colors.textFaint} />
      ) : null}
      <T size={14} weight={700} color={colors.gold}>
        {fmt(order.total)}
      </T>
      <Icon name="chevronRight" size={16} color={colors.textFaint} />
    </Pressable>
  );
}
